import { Expose, Type } from 'class-transformer';
import { RepeatableGuestDto } from './repeatable-guest.dto';

export class GetRepeatableGuestsPaginationResponseDto {
  @Expose({ name: 'totalPages' })
  totalPages: number;
  @Expose({ name: 'totalResults' })
  totalResults: number;
  @Expose({ name: 'guests' })
  @Type(() => RepeatableGuestDto)
  guests: RepeatableGuestDto[];
}
